module.exports = __webpack_public_path__ + "static/img/0201_03.d842435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0201_03.jpg
// module id = CMmC
// module chunks = 1